<template>
  <div>
    <table class='confirmation-table'>
      <tr>
        <td>{{ 'report-of-sickness.first-of-absence' | translate }}</td>
        <td>{{getFormattedDate(firstOfAbsence)}}</td>
      </tr>
      <tr>
        <td>{{ 'report-of-sickness.disability-rate' | translate }}</td>
        <td>{{disabilityRate}} %</td>
      </tr>
      <tr>
        <td>{{ 'report-of-sickness.safetynet' | translate }}</td>
        <td>{{getSafetyNetText()}}</td>
      </tr>
      <tr>
        <td>{{ 'report-of-sickness.accident' | translate }}</td>
        <td>{{getAccidentText()}}</td>
      </tr>
      <tr v-if="accident === true">
        <td>{{ 'report-of-sickness.third-party-liability' | translate }}</td>
        <td>{{getThirdPartyLiabilityText()}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import HelperFunctions from '@/shared/helpers/functions';

export default {
  name: 'NewReportOfSicknessConfirmationBox',
  methods: {
    getSafetyNetText () {
      if (this.safetyNet === true) return this.$t('report-of-sickness.form.yes-safetynet');
      else if (this.safetyNet === false) return this.$t('report-of-sickness.form.no-safetynet');
      else return this.$t('forms.no-entry');
    },
    getAccidentText () {
      if (this.accident === true) return this.$t('report-of-sickness.form.yes-accident');
      else if (this.accident === false) return this.$t('report-of-sickness.form.no-accident');
      else return this.$t('forms.no-entry');
    },
    getThirdPartyLiabilityText () {
      if (this.thirdPartyLiability === true) return this.$t('report-of-sickness.form.yes-third-party-liability');
      else if (this.thirdPartyLiability === false) return this.$t('report-of-sickness.form.no-third-party-liability');
      else return this.$t('forms.no-entry');
    },
    getFormattedDate (value) {
      return HelperFunctions.Dates.formatDate(value);
    }
  },
  computed: {
    firstOfAbsence () {
      return this.$store.getters.newReportOfSickness.firstOfAbsence;
    },
    disabilityRate () {
      return this.$store.getters.newReportOfSickness.disabilityRate;
    },
    safetyNet () {
      return this.$store.getters.newReportOfSickness.safetyNet;
    },
    accident () {
      return this.$store.getters.newReportOfSickness.accident;
    },
    thirdPartyLiability () {
      return this.$store.getters.newReportOfSickness.thirdPartyLiability;
    }
  }
};
</script>
